import {
  call, takeLatest, all, put,
} from 'redux-saga/effects';
import api from 'services/api';
import { Types, Creators } from 'store/ducks/account/validateAccount';
import { Creators as NotificationCreators } from 'store/ducks/app';
import interceptResponse from 'utils/request/interceptResponse';
import interceptError from 'utils/request/interceptError';

function* getValidateAccountRequest({ payload }) {
  try {
    const {
      hash,
    } = payload;

    const response = yield call(api.put, '/v1/client/confirm', {
      hash,
    });

    
    if (response.status !== 200) throw response;
    yield put(Creators.getValidateAccountSuccess(response.data));
    yield put(
      NotificationCreators.openNotification({ message: response.data.msg, type: 'success' }),
    );
  } catch (err) {
    if (err.status == 401){
      yield put(Creators.getValidateAccountFailure('Ops! Problema no servidor, email já pode ter sido verificado!'));
    }
  }
}

export default function* ValidateSaga() {
  yield all([
    takeLatest(Types.GET_VALIDATE_REQUEST, getValidateAccountRequest),
  ]);
}
